import axios from '../axios'

export const selectIntegralItem = params => {
    return axios({
        url: '/v1/integralItem',
        method: 'get',
        params
    })
};

export const insertIntegralItem = data => {
    return axios({
        url: '/v1/integralItem',
        method: 'post',
        data
    })
};

export const selectTotalIntegralItem = data => {
    return axios({
        url: '/v1/total/integralItem',
        method: 'get',
        data
    })
};